import type { FC } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import type { LabelsType } from "../HistoryTable";

import styles from "./MobileHistoryCards.module.scss";

const { sanitize } = dompurify;

export type HistoryTableRowProps = {
  date?: string;
  event?: string;
  points?: string;
  balance?: number;
  status: boolean;
  isReferral: boolean;
};

export type MobileHistoryCardsProps = {
  rows: HistoryTableRowProps[];
  labels: LabelsType;
  isReferral: boolean;
};

export const MobileHistoryCards: FC<MobileHistoryCardsProps> = ({ rows, labels, isReferral }) => {
  return (
    <div data-testid={"mobileHistoryCardsContainer"} className={styles.cardsContainer}>
      {rows.map((row, index) => (
        <div key={index} className={styles.card} data-testid="historyCard">
          <div className={styles.cardRow}>
            <div className={styles.rowLabel} data-testid="historyCardDateLabel">
              {labels.date}
            </div>
            <div className={styles.rowValue} data-testid="historyCardDateValue">
              {row.date}
            </div>
          </div>
          <div className={styles.cardRow}>
            <div className={styles.rowLabel} data-testid="historyCardEventLabel">
              {labels.event}
            </div>
            <div className={styles.rowValue} data-testid="historyCardEventValue">
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitize(row.event ?? ""),
                }}
              ></div>
            </div>
          </div>
          <div className={styles.pointsRow}>
            <div className={styles.cardRow}>
              <div className={styles.rowLabel} data-testid="historyCardPointsLabel">
                {labels.points}
              </div>
              <div className={classNames(styles.rowValue, styles.status)} data-testid="historyCardPointsValue">
                <div
                  className={classNames(styles.bullet, {
                    [styles.success]: row.status,
                  })}
                ></div>
                {row.points}
              </div>
            </div>
            {!isReferral && (
              <div className={classNames(styles.cardRow, styles.balanceRow)}>
                <div className={styles.rowLabel} data-testid="historyCardBalanceLabel">
                  {labels.balance}
                </div>
                <div className={styles.rowValue} data-testid="historyCardBalanceValue">
                  {row.balance}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
